module.exports = __webpack_public_path__ + "static/media/barraDesplegar.8d27b590.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/barraDesplegar.svg
// module id = 1812
// module chunks = 0